module.exports = __webpack_public_path__ + "img/ms20.b612ba8d.jpg";